import { IProviderDataResponse } from "../interface/provider-data";
import IDataConnection from "../interface/data-connection";
// import axios, { AxiosResponse } from "axios";
import IApi3SchemaTable from "../interface/api3-schema";

// todo - import from common
export enum Api3Route {
    ConnectionEstablish = 'connection_establish',
    ConnectionGetSchema = 'connection_getschema',
    ConnectionGetData = 'connection_getdata'
}

// todo - import from common
export interface IApiInstance {

    name: string;

    address: string;

    hostnames: string[];

}

// axios.defaults.withCredentials = true;

// axios.interceptors.response.use(undefined, (error: any) => {
//     // if (error) {
//     //     if (error.response && error.response.status === 401) {
//     //         Store.dispatch({
//     //             type: authLogout.fulfilled.type,
//     //             payload: { auth: false, user: null } as IDataLogin
//     //         });
//     //         Store.dispatch(apiAuthFailure());
//     //     } else if (error.message === 'Network Error') {
//     //         Store.dispatch(apiNetworkFailure());
//     //     } else if (error.response.status !== 422) {
//     //         Store.dispatch(apiInternalFailure());
//     //         if (error.response && error.response.status === 500) {
//     //             log(error.response.data);
//     //         }
//     //     }
//     // }
//     // throw error;
// });

// export type Response<T> = AxiosResponse<T>;

export type Response<T> = any;

class Api3Singleton {

    private instance: IApiInstance | null = { name: 'local', address: 'http://localhost:8091', hostnames: ['*'] };

    /* Public methods */

    public setInstance(instance: IApiInstance): void {
        // LocalStorage.setItem(StorageItem.INSTANCE, instance);
        this.instance = instance;
    }

    public async connectionEstablish(connection: IDataConnection): Promise<Response<boolean>> {
        return await this.request<boolean, IDataConnection>(Api3Route.ConnectionEstablish, connection);
    }

    public async connectionGetSchema(connection: IDataConnection): Promise<Response<IApi3SchemaTable[]> | null> {
        try {
            return await this.request<IApi3SchemaTable[], IDataConnection>(Api3Route.ConnectionGetSchema, connection);
        } catch (e) {
            return null;
        }
    }

    public async connectionGetData(connection: IDataConnection): Promise<Response<IProviderDataResponse[]> | null> {
        try {
            return await this.request<IProviderDataResponse[], IDataConnection>(Api3Route.ConnectionGetData, connection);
        } catch (e) {
            return null;
        }
    }

    /* Private methods */

    private async request<T, D>(method: string, params?: D): Promise<Response<T>> {
        if (this.instance) {
            // return await axios.post(`${this.instance.address}/${method}`, params);
            throw 'Install axios'
        } else {
            throw new Error('Trying to request an api without instance defined');
        }
    }

}

const Api3: Api3Singleton = new Api3Singleton();

export default Api3;